import React from 'react';
import cx from 'classnames';

import { PageHelperLink } from './page-helper-link';

import style from './style.less';

export function Page({ title, description, children, className, helper }) {
  return (
    <div className={cx(style.container, className)}>
      <header>
        <div className={style['header-container']}>
          <h1>
            <div>{title}</div>
          </h1>
          <div>{helper}</div>
        </div>
        {description && <div className={style['header-description']}>{description}</div>}
      </header>
      <main>{children}</main>
    </div>
  );
}

Page.PageHelperLink = PageHelperLink;

export default Page;
